<div class="container">
    <h3>Company Info</h3>
    <div class="row">
        <rb-form-input
            name="companyName"
            label="Company Name*"
            maxlength="100"
            [(ngModel)] = "customerName"
            [autofocus]="true"
            required>
            <ng-template rbFormValidationMessage="required">Company name is required</ng-template>
        </rb-form-input>
    </div>
    <div class="row">
        <rb-form-input
            name="email"
            label="E-Mail*"
            [(ngModel)]="customerMail"
            required
            email>
            <ng-container *rbFormValidationMessage="'required'; onTouched: true">
            E-Mail is required
            </ng-container>
            <ng-template rbFormValidationMessage="email" [rbFormValidationMessageOnTouched]="true">
                E-Mail is invalid
            </ng-template>
        </rb-form-input>
    </div>
    <hr>
    <div class="row">
        <div class="col-6">
            <rb-form-input
                name="street"
                label="Street*"
                maxlength="100"
                [(ngModel)] = "customerStreet"
                required>
                <ng-template rbFormValidationMessage="required">Company street is required</ng-template>
        </rb-form-input>
        </div>
        <div class="col-6">
            <rb-form-input
                name="city"
                label="City*"
                maxlength="100"
                [(ngModel)] = "customerCity"
                required>
                <ng-template rbFormValidationMessage="required">Company city is required</ng-template>
            </rb-form-input>
        </div>
    </div>
    <div class="row">
        <div class="col-4">
            <rb-form-input
                name="state"
                label="State*"
                maxlength="100"
                [(ngModel)] = "customerState"
                required>
                <ng-template rbFormValidationMessage="required">Company state is required</ng-template>
            </rb-form-input>
        </div>
        <div class="col-4">
            <rb-form-input
                name="postalCode"
                label="Postal Code*"
                [(ngModel)] = "customerZip"
                required>
                <ng-template rbFormValidationMessage="required">Company postal code is required</ng-template>
            </rb-form-input>
        </div>
        <div class="col-4">
            <rb-form-input
                class="small-input"
                [(ngModel)]="customerCountry"
                label="Country*"
                placeholder="Search here"
                [rbFormInputAutocomplete]="searchFunc"
                [rbInitialOpen]="true"
                required>
                <ng-template rbFormValidationMessage="required">Company country is required</ng-template>
            </rb-form-input>
        </div>
    </div>
    <div class="row">
        <rb-form-input
            name="additionalAddress"
            label="Additional Address"
            maxlength="150"
            [(ngModel)] = "customerAdditionalAddress">
        </rb-form-input>
    </div>
    <hr>
    <div class="row" *ngIf="customerCountry !== 'United States (US)' && customerCountry !== ''">
        <rb-form-input
            name="vatNumber"
            label="VAT Number*"
            maxlength="100"
            [(ngModel)] = "customerVatNumber"
            class="countryDropdown"
            required>
            <ng-template rbFormValidationMessage="required">Company VAT Number is required</ng-template>
        </rb-form-input>
    </div>
    <div class="row">
        <div class="col-12  d-flex justify-content-end">
            <button type="button" class="rb-btn rb-primary" (click)="sendCompanyData()" [disabled]="disableConfirmButton()">
                <span class="rb-ic rb-ic-checkmark"></span>&nbsp; Confirm
            </button>
        </div>
    </div>
</div>
